import { render, staticRenderFns } from "./MoreBoxContent.vue?vue&type=template&id=298dd536&scoped=true"
import script from "./MoreBoxContent.vue?vue&type=script&lang=ts"
export * from "./MoreBoxContent.vue?vue&type=script&lang=ts"
import style0 from "./MoreBoxContent.vue?vue&type=style&index=0&id=298dd536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298dd536",
  null
  
)

export default component.exports